module.exports = __webpack_public_path__ + "img/Renofloor_1.a024f0d2.jpg";